import { trackAnalyticsEvent } from 'app/actions/AnalyticsGa4Actions';
import { eventNames, METADATA_CATEGORY_TYPE, UI_COMPONENT_TYPE } from 'app/constants/AnalyticsGa4Constants';
import { mapDisplayBibToAnalyticsBibEntity } from 'app/helpers/displayBib';

const trackBibClick = ({
  displayAvailability,
  displayBib,
  entities = {},
  itemPosition,
  uiContainerPosition,
  uiContainerTitle,
  uiContainerType
}) => {
  const { title } = displayBib;

  return trackAnalyticsEvent({
    entities: {
      ...entities,
      bib: mapDisplayBibToAnalyticsBibEntity(displayBib, displayAvailability),
      metadata: {
        metadata_category_type: METADATA_CATEGORY_TYPE.BIBLIOGRAPHIC_DETAILS_TITLE,
        metadata_value: title
      },
      ui: {
        ui_component_type: UI_COMPONENT_TYPE.LINK_IMAGE,
        ui_container_position: uiContainerPosition,
        ui_container_title: uiContainerTitle,
        ui_container_type: uiContainerType,
        ui_content_position: itemPosition
      }
    },
    eventName: eventNames.CONTENT_CLICK
  });
};

const trackBibsRowTitleClick = ({ entities = {}, linkText, linkUrl, uiContainerPosition, uiContainerType }) => {
  return trackAnalyticsEvent({
    entities: {
      ...entities,
      metadata: {
        metadata_category_type: METADATA_CATEGORY_TYPE.BROWSE,
        metadata_value: linkUrl
      },
      ui: {
        ui_component_label: linkText,
        ui_component_type: UI_COMPONENT_TYPE.LINK_HEADING,
        ui_container_position: uiContainerPosition,
        ui_container_title: linkText,
        ui_container_type: uiContainerType
      }
    },
    eventName: eventNames.CONTENT_EXPLORE
  });
};

const trackLinksRowLinkClick = ({
  entities = {},
  itemPosition,
  linkText,
  linkUrl,
  uiContainerPosition,
  uiContainerTitle,
  uiContainerType
}) => {
  return trackAnalyticsEvent({
    entities: {
      ...entities,
      metadata: {
        metadata_category_type: METADATA_CATEGORY_TYPE.BROWSE,
        metadata_value: linkUrl
      },
      ui: {
        ui_component_label: linkText,
        ui_component_type: UI_COMPONENT_TYPE.LINK_TEXT,
        ui_container_position: uiContainerPosition,
        ui_container_title: uiContainerTitle,
        ui_container_type: uiContainerType,
        ui_content_position: itemPosition
      }
    },
    eventName: eventNames.CONTENT_EXPLORE
  });
};

const trackListCreatorClick = ({
  creatorName,
  entities = {},
  itemPosition,
  list,
  uiContainerPosition,
  uiContainerTitle,
  uiContainerType
}) => {
  return trackAnalyticsEvent({
    entities: {
      ...entities,
      list: {
        list_id: list.id,
        list_purpose: (list.listType || '').toLowerCase(),
        list_title: list.name,
        list_visibility: list.visibility
      },
      metadata: {
        metadata_category_type: METADATA_CATEGORY_TYPE.USER,
        metadata_value: creatorName
      },
      ui: {
        ui_component_label: creatorName,
        ui_component_type: UI_COMPONENT_TYPE.LINK_TEXT,
        ui_container_position: uiContainerPosition,
        ui_container_title: uiContainerTitle,
        ui_container_type: uiContainerType,
        ui_content_position: itemPosition
      }
    },
    eventName: eventNames.CONTENT_EXPLORE
  });
};

const trackListImageClick = ({
  entities = {},
  impressionId,
  itemPosition,
  list,
  uiContainerPosition,
  uiContainerTitle,
  uiContainerType
}) => {
  return trackAnalyticsEvent({
    entities: {
      ...entities,
      list: {
        list_id: list.id,
        list_purpose: (list.listType || '').toLowerCase(),
        list_title: list.name,
        list_visibility: list.visibility
      },
      properties: {
        impression_id: impressionId
      },
      ui: {
        ui_component_type: UI_COMPONENT_TYPE.LINK_IMAGE,
        ui_container_position: uiContainerPosition,
        ui_container_title: uiContainerTitle,
        ui_container_type: uiContainerType,
        ui_content_position: itemPosition
      }
    },
    eventName: eventNames.CONTENT_CLICK
  });
};

const trackListImpression = ({
  entities = {},
  impressionId,
  itemPosition,
  list,
  uiContainerPosition,
  uiContainerTitle,
  uiContainerType
}) => {
  return trackAnalyticsEvent({
    entities: {
      ...entities,
      list: {
        list_id: list.id,
        list_purpose: (list.listType || '').toLowerCase(),
        list_title: list.name,
        list_visibility: list.visibility
      },
      ui: {
        ui_container_position: uiContainerPosition,
        ui_container_title: uiContainerTitle,
        ui_container_type: uiContainerType,
        ui_content_position: itemPosition
      }
    },
    eventName: eventNames.CONTENT_IMPRESSION,
    properties: {
      impression_id: impressionId
    }
  });
};

const trackListTitleClick = ({
  entities = {},
  impressionId,
  itemPosition,
  list,
  uiContainerPosition,
  uiContainerTitle,
  uiContainerType
}) => {
  return trackAnalyticsEvent({
    entities: {
      ...entities,
      list: {
        list_id: list.id,
        list_purpose: (list.listType || '').toLowerCase(),
        list_title: list.name,
        list_visibility: list.visibility
      },
      ui: {
        ui_component_label: list.name,
        ui_component_type: UI_COMPONENT_TYPE.LINK_TEXT,
        ui_container_position: uiContainerPosition,
        ui_container_title: uiContainerTitle,
        ui_container_type: uiContainerType,
        ui_content_position: itemPosition
      }
    },
    eventName: eventNames.CONTENT_CLICK,
    properties: {
      impression_id: impressionId
    }
  });
};

const trackNavLinkClick = ({
  entities = {},
  itemPosition,
  linkText,
  linkUrl,
  uiContainerPosition,
  uiContainerTitle,
  uiContainerType
}) => {
  return trackAnalyticsEvent({
    entities: {
      ...entities,
      metadata: {
        metadata_category_type: METADATA_CATEGORY_TYPE.NAVIGATION,
        metadata_value: linkUrl
      },
      ui: {
        ui_component_label: linkText,
        ui_component_type: UI_COMPONENT_TYPE.LINK_TEXT,
        ui_container_position: uiContainerPosition,
        ui_container_title: uiContainerTitle,
        ui_container_type: uiContainerType,
        ui_content_position: itemPosition
      }
    },
    eventName: eventNames.NAVIGATE
  });
};

export {
  trackBibClick,
  trackBibsRowTitleClick,
  trackLinksRowLinkClick,
  trackListCreatorClick,
  trackListImageClick,
  trackListImpression,
  trackListTitleClick,
  trackNavLinkClick
};
